import isaacPic from "@/public/images/artists/isaac.png";
import { Artist } from "@/types/types";

export const isaac = {
  id: "187",
  name: "Isaac",
  image: isaacPic,
  description: `Isaac's vocal delivery is direct and balanced, with a warm lower register and a crisp mid-range. His versatile, modern sound pairs nicely with both electronic tracks and acoustic arrangements.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fisaac-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Dance", "Country", "Pop", "Rock"],
      secondary: ["Processed"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 71,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
